<template>
    <form ref="form">
        <span style="display: none"> {{detail}} </span>
        <b-tabs justified content-class="mt-3"  align="center">
            <validation-observer ref="receiver">
                <b-tab title="Genel Ayarlar">
                    <b-form-group>
                        <b-row>
                            <b-col sm="2"> <label> Receiver No:</label> </b-col>
                            <b-col sm="4"> 
                                <validation-provider name="Receiver No" :rules="{ required: true, numeric: true}" v-slot="validationContext">
                                    <b-form-input v-model="rec_no" placeholder="Receiver No" :state="getValidationState(validationContext)" />
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider>
                            </b-col>
                            <b-col sm="2"> <label> Receiver Code:</label> </b-col>
                            <b-col sm="4"> 
                                <validation-provider name="Receiver Code" :rules="{ required: true}" v-slot="validationContext">
                                    <b-form-input v-model="rec_code" placeholder="Receiver Code" :state="getValidationState(validationContext)" />
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider>
                            </b-col>
                        </b-row>
                    </b-form-group>
                    <b-form-group>
                        <b-row>
                            <b-col sm="2"> <label> Receiver Adı:</label> </b-col>
                            <b-col sm="4"> 
                                <validation-provider name="Receiver Adı" :rules="{ required: true}" v-slot="validationContext">
                                    <b-form-input v-model="name" placeholder="Receiver Adı" :state="getValidationState(validationContext)" />
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider>
                            </b-col>
                            <b-col sm="2"> <label> Receiver Ön Ek</label> </b-col>
                            <b-col sm="4"> <b-form-input v-model="prefix" placeholder="Receiver Ön Ek" /></b-col>
                        </b-row>
                    </b-form-group>
                    <b-form-group>
                        <b-row>
                            <b-col sm="2"> <label> Aktif</label> </b-col>
                            <b-col sm="4"> 
                                <b-form-radio-group
                                    id="is_active"
                                    v-model="is_active"
                                    :options="states"
                                    aria-describedby="live-feedback"></b-form-radio-group>
                            </b-col>
                            <b-col sm="2"> <label> Receiver Protokolü</label> </b-col>
                            <b-col sm="4">
                                <validation-provider name="Receiver Protokolü" :rules="{ required: true, is_not:0}" v-slot="validationContext">
                                     <Multiselect  
                                        v-model="receiver_protocol"
                                        :show-labels="false" 
                                        :options="protocol"
                                        label="name"
                                        track-by="id" 
                                        :state="getValidationState(validationContext)" >
                                            <template slot="singleLabel" slot-scope="{ option }">
                                                <strong>{{ option.name }} </strong> 
                                            </template>
                                    </Multiselect>
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider>
                            </b-col>
                        </b-row>
                    </b-form-group>
                </b-tab>
                <b-tab title="Bağlantı Ayarları">
                    <b-form-group>
                        <b-row>
                            <b-col sm="4"> <label> Receiver Tipi</label> </b-col>
                            <b-col sm="8">
                                <b-form-radio-group
                                    id="is_ip_recevier"
                                    v-model="is_ip_recevier"
                                    :options="types"
                                    aria-describedby="live-feedback"></b-form-radio-group>
                            </b-col>
                        </b-row>
                    </b-form-group>
                    <template v-if="is_ip_recevier">
                        <b-form-group>
                            <b-row>
                                <b-col sm="2"> <label> IP</label> </b-col>
                                <b-col sm="4"> 
                                    <validation-provider name="IP" :rules="{ required: is_ip_recevier}" v-slot="validationContext">
                                        <b-form-input v-model="ip" placeholder="IP" :state="getValidationState(validationContext)" />
                                        <b-form-invalid-feedback id="live-feedback" style="display: block">
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </validation-provider>
                                </b-col>
                                <b-col sm="2"> <label> Port</label> </b-col>
                                <b-col sm="4">
                                    <validation-provider name="IP" :rules="{ required: is_ip_recevier}" v-slot="validationContext">
                                        <b-form-input v-model="port" placeholder="Receiver Port" :state="getValidationState(validationContext)" />
                                        <b-form-invalid-feedback id="live-feedback" style="display: block">
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </validation-provider>
                                </b-col>
                            </b-row>  
                        </b-form-group>
                        <b-form-group>
                            <b-row>
                                <b-col sm="2"> <label> IP Sunucu </label> </b-col>
                                <b-col sm="4"> 
                                    <b-form-radio-group
                                        id="is_tcp_server"
                                        v-model="is_tcp_server"
                                        :options="yesNo"
                                        aria-describedby="live-feedback"></b-form-radio-group>
                                </b-col>
                                <b-col sm="2"> <label> Komut Sunucu </label> </b-col>
                                <b-col sm="4"> 
                                    <b-form-radio-group
                                        id="is_cmd_server_active"
                                        v-model="is_cmd_server_active"
                                        :options="yesNo"
                                        aria-describedby="live-feedback"></b-form-radio-group>
                                </b-col>
                            </b-row> 
                        </b-form-group>
                        <template v-if="is_cmd_server_active">
                            <b-form-group>
                                    <b-row>
                                        <b-col sm="2"> <label> IP</label> </b-col>
                                        <b-col sm="4"> 
                                            <validation-provider name="IP" :rules="{ required: is_cmd_server_active}" v-slot="validationContext">
                                                <b-form-input v-model="cmd_server_ip" placeholder="Komut Sunucu IP" :state="getValidationState(validationContext)" />
                                                <b-form-invalid-feedback id="live-feedback" style="display: block">
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-col>
                                        <b-col sm="2"> <label> Port</label> </b-col>
                                        <b-col sm="4"> 
                                            <validation-provider name="IP" :rules="{ required: is_cmd_server_active}" v-slot="validationContext">
                                                <b-form-input v-model="cmd_server_port" placeholder="Komut Sunucu Port" :state="getValidationState(validationContext)" />
                                                <b-form-invalid-feedback id="live-feedback" style="display: block">
                                                    {{ validationContext.errors[0] }}
                                                </b-form-invalid-feedback>
                                            </validation-provider>
                                        </b-col>
                                    </b-row> 
                                </b-form-group>
                        </template>
                    </template>
                    <template v-else>
                        <b-form-group>
                            <b-row>
                                <b-col sm="2"> <label> Comport No</label> </b-col>
                                <b-col sm="4"> 
                                    <validation-provider name="IP" :rules="{ required: !is_ip_recevier, numeric: true}" v-slot="validationContext">
                                        <b-form-input v-model="com_no" placeholder="Comport No" :state="getValidationState(validationContext)" />
                                        <b-form-invalid-feedback id="live-feedback" style="display: block">
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </validation-provider>
                                </b-col>
                                <b-col sm="2"> <label> SFW Flow Control</label> </b-col>
                                <b-col sm="4">
                                    <validation-provider name="SFW Flow Control" :rules="{ required: !is_ip_recevier}" v-slot="validationContext">
                                        <Multiselect  
                                            v-model="sfw_flow_control"
                                            :show-labels="false" 
                                            :options="flowControls"
                                            label="text"
                                            track-by="value" >
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <strong>{{ option.text }} </strong> 
                                                </template>
                                        </Multiselect>
                                        <b-form-invalid-feedback id="live-feedback" style="display: block">
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </validation-provider>
                                </b-col>
                            </b-row>  
                        </b-form-group>
                        <b-form-group>
                            <b-row>
                                <b-col sm="2"> <label> Baudrate</label> </b-col>
                                <b-col sm="4"> 
                                    <validation-provider name="Baudrate" :rules="{ required: !is_ip_recevier}" v-slot="validationContext">
                                        <Multiselect  
                                            v-model="baudrate"
                                            :show-labels="false" 
                                            :options="baudrates"
                                            label="text"
                                            track-by="value" >
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <strong>{{ option.text }} </strong> 
                                                </template>
                                        </Multiselect>
                                        <b-form-invalid-feedback id="live-feedback" style="display: block">
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </validation-provider>
                                </b-col>
                                <b-col sm="2"> <label> Parite</label> </b-col>
                                <b-col sm="4"> 
                                    <validation-provider name="Parite" :rules="{ required: !is_ip_recevier}" v-slot="validationContext">
                                        <Multiselect  
                                            v-model="parite"
                                            :show-labels="false" 
                                            :options="parites"
                                            label="text"
                                            track-by="value" >
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <strong>{{ option.text }} </strong> 
                                                </template>
                                        </Multiselect>
                                        <b-form-invalid-feedback id="live-feedback" style="display: block">
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </validation-provider>
                                </b-col>
                            </b-row>  
                        </b-form-group>
                        <b-form-group>
                            <b-row>
                                <b-col sm="2"> <label> Data Bit</label> </b-col>
                                <b-col sm="4"> 
                                    <validation-provider name="Data Bit" :rules="{ numeric: true}" v-slot="validationContext">
                                        <b-form-input v-model="data_bit" placeholder="Data Bit" :state="getValidationState(validationContext)" />
                                        <b-form-invalid-feedback id="live-feedback" style="display: block">
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </validation-provider>
                                </b-col>
                                <b-col sm="2"> <label> Stop Bit</label> </b-col>
                                <b-col sm="4">
                                    <validation-provider name="Stop Bit" :rules="{ numeric: true}" v-slot="validationContext">
                                        <b-form-input  v-model="stop_bit" placeholder="Stop Bit" :state="getValidationState(validationContext)" />
                                        <b-form-invalid-feedback id="live-feedback" style="display: block">
                                            {{ validationContext.errors[0] }}
                                        </b-form-invalid-feedback>
                                    </validation-provider> 
                                </b-col>
                            </b-row>  
                        </b-form-group>
                        <b-form-group>
                            <b-row>
                                <b-col sm="12" style="display: flex; flex-direction: row; justify-content: center"> 
                                
                                        <b-form-checkbox name="dtr" v-model="dtr">DTR</b-form-checkbox>
                                        <b-form-checkbox name="rts" v-model="rts">RTS</b-form-checkbox>
                                        <b-form-checkbox name="use_dtr" v-model="use_dtr">DTR Kullan</b-form-checkbox>
                                        <b-form-checkbox name="use_rts" v-model="use_rts">RTS Kullan</b-form-checkbox>
                                        <b-form-checkbox name="req_dsr" v-model="req_dsr">DSR Zorunlu</b-form-checkbox>
                                        <b-form-checkbox name="req_cts" v-model="req_cts">CTS Zorunlu</b-form-checkbox>

                                </b-col>
                            </b-row>  
                        </b-form-group>
                    </template>
                </b-tab>
                <b-tab title="Receiver Ayarları">
                    <b-form-group>
                        <b-row>
                            <b-col sm="2"> <label> ACK </label> </b-col>
                            <b-col sm="2"> 
                                <validation-provider name="ACK" :rules="{ numeric: true}" v-slot="validationContext">
                                    <b-form-input  v-model="ack_byte" placeholder="ACK" :state="getValidationState(validationContext)" />
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider> 
                            </b-col>
                            <b-col sm="2"> <label> NACK </label> </b-col>
                            <b-col sm="2"> 
                                <validation-provider name="NACK" :rules="{ numeric: true}" v-slot="validationContext">
                                    <b-form-input  v-model="nack_byte" placeholder="NACK" :state="getValidationState(validationContext)" />
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider> 
                            </b-col>
                            <b-col sm="2"> <label> Data Boyutu</label> </b-col>
                            <b-col sm="2">
                                <validation-provider name="Data Boyutu" :rules="{ numeric: true}" v-slot="validationContext">
                                    <b-form-input  v-model="date_len" placeholder="Data Boyutu" :state="getValidationState(validationContext)" />
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider> 
                            </b-col>
                        </b-row>  
                    </b-form-group>
                    <b-form-group>
                        <b-row>
                            <b-col sm="2"> <label> Handshake Kodu</label> </b-col>
                            <b-col sm="4"> 
                                <validation-provider name="Data Boyutu" :rules="{ numeric: true}" v-slot="validationContext">
                                    <b-form-input v-model="hsk_period" placeholder="Handshake Süresi" :state="getValidationState(validationContext)" />
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider>
                            </b-col>
                            <b-col sm="2"> <label> Handshake String</label> </b-col>
                            <b-col sm="4"> <b-form-input v-model="hsk_string" placeholder="Handshake String" /></b-col>
                        </b-row>  
                    </b-form-group>
                    <b-form-group>
                        <b-row>
                            <b-col sm="2"> <label> EDS (End String) </label> </b-col>
                            <b-col sm="4">
                                <validation-provider name="EDS (End String) " :rules="{ numeric: true}" v-slot="validationContext">
                                    <b-form-input  v-model="terminate_byte" placeholder="EDS (End String) " :state="getValidationState(validationContext)" />
                                    <b-form-invalid-feedback id="live-feedback" style="display: block">
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </validation-provider> 
                            </b-col>
                            <b-col sm="2"> <label style="width:auto !important"> Videofield'a Göre İşle </label> </b-col>
                            <b-col sm="4"> 
                                <b-form-radio-group
                                        id="is_video_field"
                                        v-model="is_video_field"
                                        :options="yesNo"
                                        aria-describedby="live-feedback"></b-form-radio-group>
                            </b-col>
                        </b-row>  
                    </b-form-group>
                </b-tab>
            </validation-observer>    
        </b-tabs>
    </form>
</template>

<script>
    import i18n from '@/plugins/i18n';
  import Multiselect from 'vue-multiselect'


    export default {
        name: "ReceiverSettings",
        props:{
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function
        },
        components:{
            Multiselect
        },
        data: function(){
            return {
                states: [{text: 'Aktif', value: true}, {text: 'Pasif', value: false}],
                types: [{text: 'IP Receiver', value: true}, {text: 'Seri Receiver', value: false}],
                baudrates: [
                    {text: '1200', value: 1200},
                    {text: '2400', value: 2400},
                    {text: '4800', value: 4800},
                    {text: '9600', value: 9600},
                    {text: '19200', value: 19200},
                    {text: '38400', value: 38400},
                    {text: '57600', value: 57600},
                ],
                parites: [
                    {text: 'None', value: 'none'},
                    {text: 'Odd', value: 'odd'},
                    {text: 'Even', value: 'even'},
                    {text: 'Mark', value: 'mark'},
                    {text: 'Space', value: 'space'}
                ],
                flowControls: [
                    {text: 'None', value: 'none'},
                    {text: 'Receive', value: 'receive'},
                    {text: 'Transmit', value: 'tranmit'},
                    {text: 'Both', value: 'both'},
                ],
                 yesNo: [
                    {text: i18n.t('general.yes'), value: true},
                    {text: i18n.t('general.no'), value: false}

                ],
                ack_byte: 0,
                baudrate: 0,
                cmd_server_ip: "",
                cmd_server_port: 0,
                com_no:  0,
                data_bit: 0,
                date_len:  0,
                dtr:  false,
                hsk_period:  0,
                hsk_string:  "",
                ip:  "",
                is_active: false,
                is_cmd_server_active: false,
                is_ip_recevier:  false,
                is_tcp_server:  false,
                is_video_field:  false,
                nack_byte: 0,
                name: "",
                parite: "",
                port:  0,
                prefix:  "",
                rec_code: 0,
                rec_no:  0,
                receiver_protocol_id:  null,
                req_cts:  false,
                req_dsr:  false,
                rts:  false,
                sfw_flow_control: "",
                start_byte: 0,
                stop_bit: 0,
                terminate_byte: 0,
                use_dtr: false,
                use_rts: false,
                receiver_protocol: null

            }
        },
        computed:{
            detail(){
                this.getDetail(this.$store.getters.getReceiverDetail)
                return this.$store.getters.getReceiverDetail;
            },
            protocol(){
                return this.$store.getters.getReceiverProtocols;
            },
            loading(){
                return this.$store.getters.getDefinationLoading;
            }
        },
         watch:{
            save: async function(data){
                if(data){
                     this.$refs.receiver.validate().then(async success => {
                        if(success){
                            let val = {
                                ack_byte: parseInt(this.ack_byte),
                                baudrate: this.baudrate ? this.baudrate.value : 0,
                                cmd_server_ip: this.cmd_server_ip,
                                cmd_server_port: parseInt(this.cmd_server_port),
                                com_no: parseInt(this.com_no),
                                data_bit: parseInt(this.data_bit),
                                date_len: parseInt(this.data_len),
                                dtr:  this.dtr,
                                hsk_period:  parseInt(this.hsk_period),
                                hsk_string:  this.hsk_string,
                                ip: this.ip,
                                is_active: this.is_active,
                                is_cmd_server_active: this.is_cmd_server_active,
                                is_ip_recevier:  this.is_ip_recevier,
                                is_tcp_server:  this.is_tcp_server,
                                is_video_field:  this.is_video_field,
                                nack_byte: parseInt(this.nack_byte),
                                name: this.name,
                                parite: this.parite ? this.parite.value : 'none',
                                port: parseInt(this.port),
                                prefix:  this.prefix,
                                rec_code: parseInt(this.rec_code),
                                rec_no:  parseInt(this.rec_no),
                                receiver_protocol_id:  this.receiver_protocol ? this.receiver_protocol.id : 0,
                                req_cts:  this.req_cts,
                                req_dsr:  this.req_dsr,
                                rts:  this.rts,
                                sfw_flow_control: this.sfw_flow_control ? this.sfw_flow_control.value : 'none' ,
                                start_byte: parseInt(this.start_byte),
                                stop_bit: parseInt(this.stop_bit),
                                terminate_byte: parseInt(this.terminate_byte),
                                use_dtr: this.use_dtr,
                                use_rts: this.use_rts,
                            }
                            
                            switch(this.modalName){
                                case "add":
                                    await this.$store.dispatch('addReceiver', val)
                                    break;  
                                case "edit":
                                    val.id = this.data.id
                                    await this.$store.dispatch('editReceiver', val)
                                    break;  
                            }
                            if(this.$store.getters.getStatus.status == "Success"){
                                this.$bvToast.toast('Receiver Ekleme / Düzenleme işlemi başarı ile gerçekleşti. Ayarlarınızın işleme geçmesi için lütfen GetSignal ve Processor servislerini yeniden başlatın', {
                                    title: 'Başarılı',
                                    variant: 'success',
                                    solid: true
                                })
                                this.$store.dispatch('listReceivers')
                            }
                        } else{
                            this.$bvToast.toast('Receiver Ekleyebilmek için lütfen tüm alanları doğru bir şekilde doldurunuz', {
                                title: 'Dikkat',
                                variant: 'danger',
                                solid: true
                            })
                        }
                     })
                }
                this.saveState(false)
            },
            data: function (val){
                this.name = val.name
            }
        },
     
        methods:{
            getDetail(data){
                if(data && this.modalName =='edit'){
                    this.baudrate = this.baudrates.find(i => i.value == data.baudrate)
                    this.ack_byte = data.ack_byte,
                    this.cmd_server_ip = data.cmd_server_ip,
                    this.cmd_server_port = data.cmd_server_port,
                    this.com_no = data.com_no,
                    this.data_bit = data.data_bit,
                    this.date_len = data.date_len,
                    this.dtr = data.dtr,
                    this.hsk_period = data.hsk_period,
                    this.hsk_string = data.hsk_string,
                    this.ip= data.ip,
                    this.is_active= data.is_active,
                    this.is_cmd_server_active= data.is_cmd_server_active,
                    this.is_ip_recevier = data.is_ip_recevier,
                    this.is_tcp_server = data.is_tcp_server,
                    this.is_video_field = data.is_video_field,
                    this.nack_byte = data.nack_byte,
                    this.name = data.name,
                    this.parite = this.parites.find(i => i.value == data.parite),
                    this.port = data.port,
                    this.prefix = data.prefix,
                    this.rec_code = data.rec_code,
                    this.rec_no = data.rec_no,
                    this.receiver_protocol_id = data.receiver_protocol_id,
                    this.receiver_protocol =  this.$store.getters.getReceiverProtocols.find(i => i.id == data.receiver_protocol_id),
                    this.req_cts = data.req_cts,
                    this.req_dsr = data.req_dsr,
                    this.rts = data.rts,
                    this.sfw_flow_control = this.flowControls.find(i => i.value == data.sfw_flow_control)
                    this.start_byte = data.start_byte,
                    this.stop_bit = data.stop_bit,
                    this.terminate_byte= data.terminate_byte,
                    this.use_dtr = data.use_dtr,
                    this.use_rts = data.use_rts
                }else{
                    this.baudrate = 0
                    this.ack_byte = 0,
                    this.cmd_server_ip = '',
                    this.cmd_server_port = 0,
                    this.com_no = 0,
                    this.data_bit = 0,
                    this.date_len = 0,
                    this.dtr = false,
                    this.hsk_period = 0,
                    this.hsk_string = '',
                    this.ip= '',
                    this.is_active= false,
                    this.is_cmd_server_active= false,
                    this.is_ip_recevier = false,
                    this.is_tcp_server = false,
                    this.is_video_field = false,
                    this.nack_byte = 0,
                    this.name = '',
                    this.parite = null,
                    this.port = 0,
                    this.prefix = '',
                    this.rec_code = '',
                    this.rec_no = 0,
                    this.receiver_protocol_id = 0,
                    this.receiver_protocol =  null,
                    this.req_cts = false,
                    this.req_dsr = false,
                    this.rts = false,
                    this.sfw_flow_control = null
                    this.stop_bit = 0,
                    this.terminate_byte= 0,
                    this.use_dtr = false,
                    this.use_rts = false
                }
            },
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Defination/modals/Receivers.vue